// ===========================================
// Shared Event Type Constants
// ===========================================
// Single canonical source for event-type colors, labels, and chip text color.
// Import from here instead of defining locally per page.
// Keys MUST match the backend EventType enum exactly.

import type { EventType } from '../api/events.api';

// Canonical color mapping — one consistent choice per event type, drawn from
// the brand palette. Light backgrounds (mint/yellow/coral/gray) get dark text;
// dark backgrounds (blue/red) get white text — see eventTypeChipTextColor.
export const EVENT_TYPE_COLORS: Record<EventType, string> = {
  CONCERT:           '#4580E4', // brand blue   → white text
  RECITAL:           '#4580E4', // brand blue   → white text
  WORKSHOP:          '#96DAC9', // mint         → dark text
  OPEN_HOUSE:        '#FFAE9E', // coral        → dark text
  MASTERCLASS:       '#FFCE00', // yellow       → dark text
  REHEARSAL:         '#96DAC9', // mint         → dark text
  RECORDING_SESSION: '#4580E4', // brand blue   → white text
  COMMUNITY_SERVICE: '#FFAE9E', // coral        → dark text
  PARENT_NIGHT:      '#FFCE00', // yellow       → dark text
  HOLIDAY_CAMP:      '#ff4040', // brand error  → white text
  OTHER:             '#9DA5AF', // neutral gray → dark text
};

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  CONCERT:           'Concert',
  RECITAL:           'Recital',
  WORKSHOP:          'Workshop',
  OPEN_HOUSE:        'Open House',
  MASTERCLASS:       'Masterclass',
  REHEARSAL:         'Rehearsal',
  RECORDING_SESSION: 'Recording Session',
  COMMUNITY_SERVICE: 'Community Service',
  PARENT_NIGHT:      'Parent Night',
  HOLIDAY_CAMP:      'Holiday Camp',
  OTHER:             'Event',
};

// Light-background types require dark (#080808) text to pass WCAG AA contrast.
// All others use white (#fff).
const LIGHT_BG_TYPES = new Set<EventType>([
  'WORKSHOP',
  'OPEN_HOUSE',
  'MASTERCLASS',
  'REHEARSAL',
  'COMMUNITY_SERVICE',
  'PARENT_NIGHT',
  'OTHER',
]);

export function eventTypeChipTextColor(type: EventType): '#080808' | '#fff' {
  return LIGHT_BG_TYPES.has(type) ? '#080808' : '#fff';
}
